import React from 'react';
import chunk from 'lodash/chunk';
import CodeSparkThemedTypography from '../../../../../components/elements/CodeSparkThemedTypography';
import { ValuePropItem, ValuePropsList } from '../../../../../components/elements/ValuePropsList';
import styles from './PlanSelectorV3.module.css';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/global`;

const chunkItemsToColumns = (items, numOfColumns) => {
  const itemsPerColumn = Math.ceil(items.length / numOfColumns);

  return chunk(items, itemsPerColumn);
};

export default function PlansInclude({ valueProps }) {
  const valuePropsColumns = chunkItemsToColumns(valueProps, 2);

  return (
    <div className={styles.planSelectorValuePropsContainer}>
      <div className={styles.planSelectorValuePropsInner}>
        {valuePropsColumns.map((columnValues, i) => {
          return (
            <ValuePropsList
              key={`plan_selector_c${i}`}
              className={styles.planSelectorValuePropList}
            >
              {columnValues.map((valueProp, j) => {
                return (
                  <ValuePropItem
                    key={`plan_selector_c${i}_value_prop_${j}`}
                    iconSize="medium"
                    icon={`${imgURL}/checkmark-updated-blue.svg`}
                    className={styles.planSelectorValueProp}
                  >
                    <CodeSparkThemedTypography
                      variant="body2"
                      className={styles.planSelectorValuePropText}
                    >
                      {valueProp}
                    </CodeSparkThemedTypography>
                  </ValuePropItem>
                );
              })}
            </ValuePropsList>
          );
        })}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/V3/PlansInclude.js